export const selectConsentsLoading = (state) => state.consents && state.consents.loading;
export const selectConsents = (state) => state.consents && state.consents.list;
